import type { ZodSimplify } from '@mntn-dev/utility-types'
import { z } from 'zod'
import { ModelFilterSchema } from '../model-filter-schema.ts'
import {
  CreditProgramKindSchema,
  CreditProgramMembershipIdSchema,
} from './billing/credit-program.ts'
import {
  OrganizationIdSchema,
  PartnerProgramIdSchema,
} from './unique-id.models.ts'

/**
 * PartnerProgramDomainSelectModel
 */
export const PartnerProgramDomainSelectModelSchema = z.object({
  partnerProgramId: PartnerProgramIdSchema,
  organizationId: OrganizationIdSchema,
  creditProgramKind: CreditProgramKindSchema,
  programMembershipId: CreditProgramMembershipIdSchema.optional(),
})

export type PartnerProgramDomainSelectModel = ZodSimplify<
  typeof PartnerProgramDomainSelectModelSchema
>

/**
 * PartnerProgramDomainInsertModel
 */
export const PartnerProgramDomainInsertModelSchema =
  PartnerProgramDomainSelectModelSchema.partial({
    partnerProgramId: true,
  })

export type PartnerProgramDomainInsertModel = ZodSimplify<
  typeof PartnerProgramDomainInsertModelSchema
>

/**
 * PartnerProgramDomainUpdateModel
 */
export const PartnerProgramDomainUpdateModelSchema =
  PartnerProgramDomainSelectModelSchema.pick({
    programMembershipId: true,
  })

export type PartnerProgramDomainUpdateModel = ZodSimplify<
  typeof PartnerProgramDomainUpdateModelSchema
>

/**
 * PartnerProgramDomainSelectModelFilters
 */
export const PartnerProgramDomainSelectModelFiltersSchema = z
  .object({
    partnerProgramId: ModelFilterSchema(PartnerProgramIdSchema),
    organizationId: ModelFilterSchema(OrganizationIdSchema),
    creditProgramKind: ModelFilterSchema(CreditProgramKindSchema),
  })
  .partial()

export type PartnerProgramDomainSelectModelFilters = ZodSimplify<
  typeof PartnerProgramDomainSelectModelFiltersSchema
>
